import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/rootStore";

export const StaffManager = observer(() => {
    const { userStore } = useStore();
    // Logic to call Firebase Cloud Function 'setUserRole'
    return (
        <div>
            <h4 className="fw-bold text-danger mb-4">Staff Permissions</h4>
            <p className="text-muted small">Only Super Admins can access this panel.</p>
            {/* Table of users with role change dropdowns */}
        </div>
    );
});